import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { PrimaryCTA } from "@/components/revanche/PrimaryCTA";
import { uploadPhoto, compressImage, previewStart } from "@/lib/photo";

const BodyPhoto = () => {
    const navigate = useNavigate();
    const inputRef = useRef(null);
    // AUCUN appel IA avant paiement : on prépare seulement l'aperçu modèle (titre + axes, sans IA).
    const next = () => { previewStart().catch(() => {}); navigate("/teasing"); };

    const onPick = async (e) => {
        const f = e.target.files?.[0];
        if (!f) return;
        const blob = await compressImage(f, 1024, 0.8);
        await uploadPhoto(blob, "full_body").catch(() => {});
        next();
    };

    return (
        <div className="fixed inset-0 bg-black max-w-[480px] mx-auto flex flex-col" data-testid="body-photo-screen">
            <div className="flex-1 min-h-0 flex flex-col justify-center" style={{ paddingLeft: 24, paddingRight: 24 }}>
                <h1 className="font-body" style={{ fontSize: "24px", fontWeight: 700, lineHeight: 1.15, color: "var(--text)" }}>
                    Ajoute une photo de toi en entier pour une analyse encore plus précise.
                </h1>
                <p className="font-body" style={{ marginTop: 8, fontSize: "16px", color: "var(--text-secondary)" }}>
                    Debout, habillé, de la tête aux pieds.
                </p>
            </div>
            <div className="shrink-0 safe-bottom flex flex-col items-center" style={{ paddingLeft: 24, paddingRight: 24, paddingBottom: 24 }}>
                <PrimaryCTA dataTestId="btn-add-body" onClick={() => inputRef.current?.click()}>
                    Ajouter ma photo
                </PrimaryCTA>
                <button
                    data-testid="btn-skip-body"
                    onClick={next}
                    className="tap-feedback underline font-body"
                    style={{ marginTop: 16, fontSize: "14px", color: "var(--text-secondary)", padding: "8px 0" }}
                >
                    Passer
                </button>
                <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={onPick} />
            </div>
        </div>
    );
};

export default BodyPhoto;
